import { LayoutHierarchyFilteringState } from './filtering-state';

// Currently nothing really happens here; we just arbitrarily pick the first actual building. This function exists to
//   provide a single "find all usages" point to start at once we decide to make this smarter.
export function pickSingleActiveBuildingGuid(choices: string[]): LayoutHierarchyFilteringState['activeBuildingGuid'] {
  return choices[0] ?? null;
}
